'use client'

import {
  CheckboxGroupItem,
  CheckboxGroupRoot,
} from '@/components/ui/checkbox-group'
import { TCardFacet, TFacet } from '@/types/collection'
import { FilterValues } from '../../../types/filter-store-v2.types'
import { shouldAddNofollowToFilterLinks } from '../../../utils/filter-utils'
import { buildFilterUrl } from './filter-url-builder'

type CheckboxItem = {
  value: string
  label: string
}

type Props = {
  onFilterChange: (value: string[]) => void
  items: CheckboxItem[] // Bắt buộc phải có items từ facets
  value?: string[]
  gaTrackingValue?: string
  gaTrackingLabel?: string
  originalSlug?: string
  currentFilters?: FilterValues
  facets?: TFacet[]
  cardFacets?: TCardFacet[]
}

export const FilterPriceRange = ({
  onFilterChange,
  items,
  value = [],
  gaTrackingValue,
  gaTrackingLabel,
  originalSlug,
  currentFilters = {},
  facets,
  cardFacets,
}: Props) => {
  const handleLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    itemValue: string
  ) => {
    e.preventDefault()
    const newValues = value.includes(itemValue)
      ? value.filter((v) => v !== itemValue)
      : [...value, itemValue]
    onFilterChange(newValues)
  }

  // Check if should add nofollow
  const shouldAddNofollow = shouldAddNofollowToFilterLinks(
    currentFilters,
    facets,
    cardFacets
  )

  // Build URL for each filter option
  const getFilterUrl = (item: CheckboxItem): string => {
    if (!originalSlug) return '#'
    const isChecked = value.includes(item.value)
    return buildFilterUrl({
      originalSlug,
      currentFilters,
      facetKey: 'price_range',
      facetValue: item.value,
      isChecked: !isChecked, // URL for toggled state
      isMultiple: true, // Price range allows multiple values
      isConcatSlug: false, // Price range doesn't use concat slug
      facets,
      cardFacets,
    })
  }

  return (
    <CheckboxGroupRoot
      name='filter-checkbox-group'
      onValueChange={(values: string[]) => onFilterChange(values)}
      value={value}
    >
      {items.map((item) => {
        const filterUrl = getFilterUrl(item)
        return (
          <CheckboxGroupItem
            key={item.value}
            value={item.value}
            title={
              <a
                href={filterUrl}
                onClick={(e) => handleLinkClick(e, item.value)}
                className='[display:contents]'
                aria-label={`Filter by ${item.label}`}
                rel={shouldAddNofollow ? 'nofollow' : undefined}
              >
                {item.label}
              </a>
            }
            ga-tracking-value={gaTrackingValue}
            ga-tracking-label={gaTrackingLabel}
          />
        )
      })}
    </CheckboxGroupRoot>
  )
}
